import BaseChart from 'components/BaseChart/BaseChart';
import { createChartOptionFromDataSets } from 'components/BaseChart/utils/chartOptionAdapter.utils';
import { useMemo } from 'react';

/**
 * Converts prepared forecast data into ECharts options and displays it through BaseChart.
 * BaseChart owns Reset Zoom and the empty message. Widgets can supply their existing
 * container styles without changing the page's default chart appearance.
 */
const ForecastChartContent = ({ chartData, chartType, customStyles }) => {
  const option = useMemo(
    () =>
      createChartOptionFromDataSets({
        type: chartType,
        dataSets: chartData?.dataSets,
        options: chartData?.options,
      }),
    [chartData, chartType],
  );

  return (
    <BaseChart option={option} customStyles={customStyles} showResetZoom lazyUpdate notMerge />
  );
};

export default ForecastChartContent;
